function togglePasswordVisibility() {
  const passwordInput = document.getElementById('CustomerPassword');
  const eyeBtn = document.querySelector('.eye-toggle-btn');
  const eyeSlashBtn = document.querySelector('.eye-toggle-btn-hidden');
  
  if (passwordInput && eyeBtn && eyeSlashBtn) {
    if (passwordInput.type === 'password') {
      // Show password - hide eye icon, show eye-slash icon
      passwordInput.type = 'text';
      eyeBtn.style.display = 'none';
      eyeSlashBtn.style.display = 'block';
      eyeSlashBtn.setAttribute('aria-label', 'Hide password');
    } else {
      // Hide password - show eye icon, hide eye-slash icon
      passwordInput.type = 'password';
      eyeBtn.style.display = 'block';
      eyeSlashBtn.style.display = 'none';
      eyeBtn.setAttribute('aria-label', 'Show password');
    }
  }
}

// Open email inbox based on email provider
function openEmailInbox(event) {
  event.preventDefault();
  
  // First, try to get email directly from the recover password form input
  const recoverEmailInput = document.getElementById('RecoverEmail');
  let email = '';
  
  if (recoverEmailInput && recoverEmailInput.value) {
    email = recoverEmailInput.value.trim();
  } else {
    // Fallback to stored email from localStorage
    email = localStorage.getItem('recoverEmail') || '';
  }
  
  let emailUrl = '';
  
  if (email) {
    const emailDomain = email.split('@')[1]?.toLowerCase();
    
    // Map common email providers to their inbox URLs
    const emailProviders = {
      'gmail.com': 'https://mail.google.com',
      'googlemail.com': 'https://mail.google.com',
      'outlook.com': 'https://outlook.live.com',
      'hotmail.com': 'https://outlook.live.com',
      'live.com': 'https://outlook.live.com',
      'msn.com': 'https://outlook.live.com',
      'yahoo.com': 'https://mail.yahoo.com',
      'ymail.com': 'https://mail.yahoo.com',
      'rocketmail.com': 'https://mail.yahoo.com',
      'aol.com': 'https://mail.aol.com',
      'icloud.com': 'https://www.icloud.com/mail',
      'me.com': 'https://www.icloud.com/mail',
      'mac.com': 'https://www.icloud.com/mail',
      'protonmail.com': 'https://mail.protonmail.com',
      'proton.me': 'https://mail.protonmail.com',
      'zoho.com': 'https://mail.zoho.com',
      'yandex.com': 'https://mail.yandex.com',
      'mail.com': 'https://www.mail.com'
    };
    
    emailUrl = emailProviders[emailDomain] || '';
  }
  
  // If we found a provider URL, open it; otherwise open Gmail as default
  if (emailUrl) {
    window.open(emailUrl, '_blank', 'noopener,noreferrer');
  } else {
    // Default to Gmail if provider not detected
    window.open('https://mail.google.com', '_blank', 'noopener,noreferrer');
  }
  
  // Clear stored email after use
  if (email) {
    localStorage.removeItem('recoverEmail');
  }
}

// Hide login form and title when success message is shown
function hideLoginContent() {
  const successContainer = document.querySelector('.success-recover-password-container');
  const loginTitle = document.getElementById('login');
  const loginForm = document.getElementById('customer-login-form');
  
  if (successContainer) {
    // Hide login title
    if (loginTitle) {
      loginTitle.style.display = 'none';
    }
    
    // Hide login form
    if (loginForm) {
      loginForm.style.display = 'none';
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  // Hide login content if success message is shown
  hideLoginContent();
  
  // Store email when recover form is submitted
  const recoverForm = document.getElementById('recover-form');
  if (recoverForm) {
    recoverForm.addEventListener('submit', function(e) {
      const emailInput = document.getElementById('RecoverEmail');
      if (emailInput && emailInput.value) {
        localStorage.setItem('recoverEmail', emailInput.value);
      }
    });
  }

  // Handle password visibility toggle
  const eyeToggleBtn = document.querySelector('.eye-toggle-btn');
  const eyeSlashToggleBtn = document.querySelector('.eye-toggle-btn-hidden');
  
  if (eyeToggleBtn) {
    eyeToggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      togglePasswordVisibility();
    });
    eyeToggleBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      togglePasswordVisibility();
    });
  }
  
  if (eyeSlashToggleBtn) {
    eyeSlashToggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      togglePasswordVisibility();
    });
    eyeSlashToggleBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      togglePasswordVisibility();
    });
  }

  // Use event delegation for "Check my inbox" button (works even if element is added dynamically)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.check-inbox-btn, .open-inbox-btn')) {
      openEmailInbox(e);
    }
  });
});

